import React, { useState, useEffect } from 'react'
import './styles.scss'

export const Timer = ({ initialMinute, initialSeconds, reset }) => {
    const [minutes, setMinutes] = useState(initialMinute)
    const [seconds, setSeconds] = useState(initialSeconds)

    useEffect(() => {
        setMinutes(initialMinute)
        setSeconds(initialSeconds)
    }, [initialMinute, initialSeconds])

    useEffect(() => {
        const myInterval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1)
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(myInterval)
                } else {
                    setMinutes(minutes - 1)
                    setSeconds(59)
                }
            }
        }, 1000)
        return () => {
            clearInterval(myInterval)
        }
    }, [minutes, seconds])

    if (minutes === 0 && seconds === 0) {
        return (
            <p className="autoLogout error">
                Your session is expired. Please
                <a role="button" style={{ marginLeft: 5, cursor: 'pointer' }} onClick={() => reset({ reload: true })}>
                    refresh now
                </a>
            </p>
        )
    }

    return (
        <p className="autoLogout">
            Auto-logout: {minutes}m {seconds < 10 ? `0${seconds}` : seconds}s
        </p>
    )
}
